module.exports = __webpack_public_path__ + "static/media/mobile-logo.a5333ae4.png";